import React, { useEffect, useContext } from 'react';
import Context from '../../../contexts/docs';

const DeferredRedirectTracker: React.FC = () => {
  const { dispatch } = useContext(Context);

  useEffect(() => {
    const sendDeferredRedirectTracking = () => {
      try {
        const redirectInfoStr = sessionStorage.getItem(
          'plaid_docs_redirect_tracking',
        );
        if (!redirectInfoStr) {
          return;
        }

        const redirectInfo = JSON.parse(redirectInfoStr);
        // Send the analytics event through the docs context system
        dispatch({
          type: 'CLIENT_REDIRECT_USED',
          payload: {
            originalHash: redirectInfo.originalHash,
            redirectPath: redirectInfo.redirectPath,
          },
        });

        // Clean up the stored redirect info
        sessionStorage.removeItem('plaid_docs_redirect_tracking');
      } catch (e) {
        // Clean up potentially corrupted data
        sessionStorage.removeItem('plaid_docs_redirect_tracking');
      }
    };

    sendDeferredRedirectTracking();
  }, [dispatch]);

  return null; // This component doesn't render anything
};

DeferredRedirectTracker.displayName = 'DeferredRedirectTracker';

export default DeferredRedirectTracker;
